/**
 * Recently viewed + pinned patients (Stage F5, STEP 7 Activity Center)
 * — purely client-side/localStorage, since no backend "recent
 * activity" or "favorites" endpoint exists anywhere
 * (`ENTERPRISE-DASHBOARD-BACKEND-MAPPING.md` §3). "Recently viewed" is
 * populated only by navigation that happens through the Command
 * Center's own Global Search/Activity Center — it does NOT observe
 * navigation elsewhere in the app (Patient/Clinical/Billing pages are
 * frozen, certified modules; this store does not hook into them).
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface RecentPatientRef {
  id: string;
  displayName: string;
  uhid: string;
}

interface RecentlyViewedState {
  recent: RecentPatientRef[];
  pinned: RecentPatientRef[];
  recordView: (patient: RecentPatientRef) => void;
  togglePin: (patient: RecentPatientRef) => void;
  isPinned: (id: string) => boolean;
}

export const useRecentlyViewedStore = create<RecentlyViewedState>()(
  persist(
    (set, get) => ({
      recent: [],
      pinned: [],

      recordView: (patient) =>
        set((state) => ({
          recent: [patient, ...state.recent.filter((entry) => entry.id !== patient.id)].slice(0, 10),
        })),

      togglePin: (patient) =>
        set((state) => {
          const alreadyPinned = state.pinned.some((entry) => entry.id === patient.id);
          return {
            pinned: alreadyPinned ? state.pinned.filter((entry) => entry.id !== patient.id) : [patient, ...state.pinned].slice(0, 20),
          };
        }),

      isPinned: (id) => get().pinned.some((entry) => entry.id === id),
    }),
    { name: 'nexao-recently-viewed' },
  ),
);
